import { Tag } from "./tag";

export type UserEquippedPet = {
  item_type: string;
  store_item: {
    store_item_id: string;
    name: string;
    slug: string;
    type: string;
    rarity?: string;
    asset_key?: string;
  };
};

export type User = {
  user_id?: string;
  email: string;
  name: string;
  role: ROLES;
  accepted_terms_of_use?: boolean;
  sms_opt_in?: boolean;
  picture_url?: string;
  phone?: string | null;
  created_at?: string;
  updated_at?: string;
  org_id?: string;
  tags: { tag: Tag }[];
  organization?: {
    org_id?: string;
    name?: string;
    type?: string;
    logo_url?: string;
  }[];
  equipped_store_items?: UserEquippedPet[];
};

export enum ROLES {
  ADMIN = "admin",
  DIRECTOR = "director",
  MANAGER = "manager",
  COACH = "coach",
  STUDENT = "student",
}
